import * as requestFromServer from "./AccountsReviewCrud";
import { AccountsReviewSlice, setLoading } from "./AccountsReviewSlice";
import { UISlice } from "../UISlice";

const { actions: accountsReviewActions } = AccountsReviewSlice;
const { actions: UIActions } = UISlice;

export const fetchAccountsReviewList =
  (type, searchTerm = "", page = 1, sortBy = "", sortDir = "asc") =>
  (dispatch) => {
    dispatch(UIActions.openLoader());
    dispatch(setLoading(true));

    let fetchFunction;
    switch (type) {
      case "pending":
        fetchFunction = requestFromServer.fetchListPendingAccountsReview;
        break;
      case "confirmed":
        fetchFunction = requestFromServer.fetchListConfirmedAccountsReview;
        break;
      case "needsModification":
        fetchFunction = requestFromServer.fetchListRejectedAccountsReview;
        break;
      default:
        fetchFunction = requestFromServer.fetchListPendingAccountsReview;
        break;
    }

    return fetchFunction(searchTerm, page, sortBy, sortDir)
      .then((response) => {
        if (response.data.status) {
          dispatch(
            accountsReviewActions.setAccountsReviewData({
              data: response.data.data,
              paginator: response.data.paginator,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(accountsReviewActions.catchError(error));
      })
      .finally(() => {
        dispatch(UIActions.closeLoader());
        dispatch(setLoading(false));
      });
  };
